import { useState } from "react";

const useMultiStepForm = (totalSteps, initialStep = 1) => {
  const [step, setStep] = useState(initialStep);

  const next = () => setStep((s) => Math.min(s + 1, totalSteps));
  const back = () => setStep((s) => Math.max(s - 1, 1));
  const goTo = (n) => setStep(n);

  return { step, next, back, goTo };
};

export default useMultiStepForm;
